import { makeVar } from '@apollo/client';
import buildNotification from 'utils/buildNotification';

export const initialData = [];
export const notificationsVar = makeVar(initialData);

export const readNotifications = () => {
  try {
    const notifications = notificationsVar();

    return notifications;
  } catch {
    return [];
  }
};

export const writeNotifications = (notifications) => {
  notificationsVar(notifications);
};

export const addNotification = (notification) => {
  const notifications = readNotifications();
  const newNotifications = [...notifications, buildNotification(notification)];
  writeNotifications(newNotifications);
};

export const removeNotification = (id) => {
  const notifications = readNotifications();
  const newNotifications = notifications.filter((notification) => notification.id !== id);
  writeNotifications(newNotifications);
};
